import React, { useEffect } from "react";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps";
import { useBidContext } from "../Bid.context";
import { Box, Button, TextField } from "@mui/material";
import { postBidSelection } from "../api";

const columns = (handleInputChange) => [
  {
    header: "Vendor",
    accessorKey: "vendorName",
    enableEditing: false,
    size: 30,
  },
  {
    header: "PO Name",
    accessorKey: "po",
    enableEditing: false,
    size: 20,
    Cell: ({ cell, row }) => (
      <TextField
        variant="standard"
        value={cell.getValue()}
        onChange={(e) => handleInputChange(row.index, "po", e.target.value)}
        style={{ width: "100%" }}
      />
    ),
  },
  {
    header: "PO Rev.",
    accessorKey: "rev",
    enableEditing: false,
    size: 20,
    Cell: ({ cell, row }) => (
      <TextField
        variant="standard"
        value={cell.getValue()}
        onChange={(e) => handleInputChange(row.index, "rev", e.target.value)}
        style={{ width: "100%" }}
      />
    ),
  },
  {
    header: "PO Title",
    accessorKey: "poTitle",
    enableEditing: false,
    size: 20,
    Cell: ({ cell, row }) => (
      <TextField
        variant="standard"
        value={cell.getValue()}
        onChange={(e) =>
          handleInputChange(row.index, "poTitle", e.target.value)
        }
        style={{ width: "100%" }}
      />
    ),
  },
];

export default function POSubmissionTable({ setAlert }) {
  const { mrqData, BidTableRows, createdPos, setCreatedPos } = useBidContext();

  console.log("submitttt BID", BidTableRows);

  const currentPos = [];

  BidTableRows.forEach((row) => {
    if (row.po && !currentPos.find((c) => c.po === row.po))
      currentPos.push({
        po: row.po,
        rev: row.rev,
        poTitle: row.poTitle,
        vendorName: row.selected?.name || "",
        vendorId: row.vendorId,
      });
  });

  useEffect(() => {
    setCreatedPos(currentPos);
  }, []);

  const handleInputChange = (rowIndex, columnId, value) => {
    setCreatedPos((prev) =>
      prev.map((row, index) =>
        index === rowIndex ? { ...row, [columnId]: value } : row,
      ),
    );
  };

  const onSubmit = async () => {
    console.log("submit pos", createdPos);

    const body = BidTableRows.map((row) => {
      const currentPo = createdPos.find((c) => c.vendorId === row.vendorId);
      return {
        ...row,
        ...currentPo,
      };
    });

    const data = await postBidSelection({
      mrqId: mrqData.id,
      bidsSelection: body,
    });
    if (data && data[0] && data[0].id) {
      setAlert("success");
    } else {
      setAlert("warning");
    }
  };

  const table = useMaterialReactTable({
    data: createdPos,
    columns: columns(handleInputChange),
    ...lightTable,

    editDisplayMode: "row",
    createDisplayMode: "row",

    // ✅ GLOBAL DEFAULT FOR ALL EDIT CELLS
    muiEditTextFieldProps: {
      variant: "standard",
      size: "small",
      fullWidth: true,
    },

    // 👉 Save new row
    onCreatingRowSave: ({ values, table }) => {
      setCreatedPos((prev) => [...prev, values]);
      table.setCreatingRow(null); // exit create mode
    },

    // 👉 Cancel create
    onCreatingRowCancel: () => {
      console.log("Create cancelled");
    },

    enableStickyHeader: true,
  });

  return (
    <Box>
      <MaterialReactTable table={table} />
      <Box sx={{ textAlign: "right", mt: 2 }}>
        <Button variant="contained" onClick={onSubmit}>
          Submit
        </Button>
      </Box>
    </Box>
  );
}
